export const SHAPE_TYPES = {
    /** Basic */
    SQUARE: 'square',
    CIRCLE: 'circle',
    TRIANGLE: 'triangle',
    PENTAGON: 'pentagon',
    HEXAGON: 'hexagon',
    ROUND_RECT: 'round-rect',
    STAR: 'star',
    PLUS: 'plus',
    TAG_LEFT: 'tag-left',
    TAG_RIGHT: 'tag-right',
    CHEVRON_LEFT: 'chevron-left',
    CHEVRON_RIGHT: 'chevron-right',
    ARROW_LEFT: 'arrow-left',
    ARROW_RIGHT: 'arrow-right',
    /** Cutout */
    SQUARE_CUTOUT: 'square-cutout',
    CIRCLE_CUTOUT: 'circle-cutout',
    ROUND_RECT_CUTOUT: 'round-rect-cutout',
    STAR_CUTOUT: 'star-cutout',
    TAG_LEFT_CUTOUT: 'tag-left-cutout',
    TAG_RIGHT_CUTOUT: 'tag-right-cutout',
    CHEVRON_LEFT_CUTOUT: 'chevron-left-cutout',
    CHEVRON_RIGHT_CUTOUT: 'chevron-right-cutout',
    ARROW_LEFT_CUTOUT: 'arrow-left-cutout',
    ARROW_RIGHT_CUTOUT: 'arrow-right-cutout',
    /** Template */
    TEMPLATE: 'template',
}

export const FILTER_VALUE = {
    ALL: 'all',
    BASIC: 'basic',
    TEMPLATE: 'template',
}

/**
 * @typedef {typeof FILTER_VALUE[keyof FILTER_VALUE]} FilterValue
 */

/**
 * @typedef {Object} TypeFilter
 * @property {FilterValue} value - Value of the filter
 * @property {string} label - Label of the filter
 */

/**
 * List of type filters
 * @type {TypeFilter[]}
 */
export const TYPE_FILTERS = [
    {
        value: FILTER_VALUE.ALL,
        label: 'All shapes',
    },
    {
        value: FILTER_VALUE.TEMPLATE,
        label: 'Your shapes',
    },
    {
        value: FILTER_VALUE.BASIC,
        label: 'Basic shapes',
    },
]
